import { updateProjectCallCategoriesDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const updateProjectCallCategoriesCallable = getCallable(
  updateProjectCallCategoriesDefinition,
);
